<template>
  <div>
    <div class="nocode-background position">
      <div class="overlay"></div>
      <div class="content"></div>
    </div>
    <div class="login-container position">
      <div class="left-section">
        <div class="left-side-image-box">
          <img src="./register.png" />
        </div>
      </div>
      <div class="right-section">
        <router-view />
        <!-- Loads Register or OTP inside layout -->
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'NoCodeBackground',
    data() {
      return {
        config: {
          overlayColor: 'rgba(0, 0, 0, 0.2)', // Indigo semi-transparent
        },
      };
    },
    async mounted() {
      document.documentElement.style.setProperty('--overlay-color', this.config.overlayColor);
    },
  };
</script>

<style>
  .iti {
    /* position: relative; */
    display: inline-block;
    top: -19px;
    left: -7px;
    width: 100%;
    border: 0px;
    z-index: 1000;
  }
  .iti input {
    width: 100%;
  }
</style>
<style scoped>
  .position {
    position: absolute;
    top: 0;
  }
  .nocode-background {
    position: relative;
    height: 100vh;
    width: 100%;
    background-image: url('https://img.freepik.com/free-photo/abstract-futuristic-background-with-3d-design_1361-3532.jpg?t=st=1748118013~exp=1748121613~hmac=7b3a3e7761f19e3cfc026571b6816c154b6a060e94b1e466cf9b3ffa4a518b3f&w=1380');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-attachment: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    animation: hueRotateBg 30s infinite linear;
  }
  @keyframes hueRotateBg {
    from {
      filter: hue-rotate(0deg);
    }

    to {
      filter: hue-rotate(360deg);
    }
  }

  .overlay {
    position: absolute;
    inset: 0;
    background-color: var(--overlay-color);
    z-index: 0;
    transition: background-color 0.3s ease;
  }
  .content {
    position: relative;
    z-index: 1;
    text-align: center;
    color: white;
    width: 100%;
  }
  .left-side-image-box {
    z-index: 5;
    text-align: center;
    color: white;
    width: 100%;
  }
  .left-side-image-box img {
    max-width: 90%;
    height: auto;
    display: block;
    margin: 0 auto;
  }

  .login-container {
    display: flex;
    flex-direction: row;
    min-height: 100vh;
    width: 100%;
    /* background-image: url("https://image.bodiscdn.com/parking/landing-hero.png");
      background-size: cover;
      background-position: center; */
    overflow: hidden;
    background-color: rgb(100 100 158 / 28%);
  }

  .left-section {
    flex: 1;
    display: flex;
    justify-content: center;
    padding: 2rem;
    box-sizing: border-box;
    min-height: 100vh;
    align-items: center;
    /* vertical center */
  }

  .right-section {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    box-sizing: border-box;
  }

  /* FULL RESPONSIVE FOR MOBILE & TABLET */
  @media (max-width: 1024px) {
    .login-container {
      flex-direction: column;

      padding: 1rem;

      background-position: top center;
    }

    .left-section {
      width: 100%;

      padding: 1rem;

      text-align: center;
    }

    .right-section {
      width: 100%;

      padding: 1rem;
    }
  }
  @media (max-width: 1024px) {
    .left-section {
      display: none;
    }
  }
</style>
